import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle, Send } from "lucide-react";
import { CONTACT } from "../data";

export const Floating = ({ onApply }) => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > window.innerHeight * 0.5);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  const wa = `https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent(CONTACT.whatsappText)}`;

  return (
    <>
      <a href={wa} target="_blank" rel="noopener noreferrer" data-testid="whatsapp-float"
        className="fixed bottom-6 left-6 z-40 h-14 w-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-lg hover:scale-110 transition-transform"
        aria-label="WhatsApp us">
        <MessageCircle size={26} />
      </a>
      <AnimatePresence>
        {show && (
          <motion.button initial={{ opacity: 0, y: 30, scale: 0.8 }} animate={{ opacity: 1, y: 0, scale: 1 }} exit={{ opacity: 0, y: 30, scale: 0.8 }}
            onClick={onApply} data-testid="apply-float"
            className="fixed bottom-6 right-6 z-40 btn-primary pulse-btn px-6 py-4 inline-flex items-center gap-2 font-semibold">
            <Send size={18} /> Apply Now
          </motion.button>
        )}
      </AnimatePresence>
    </>
  );
};
